import { nextTick } from 'vue'
import type { RouteLocationNormalized, RouterScrollBehavior } from 'vue-router'

// vue-router does not scroll at all once a `scrollBehavior` exists, so the position has to be given back here. The browser's
// own back button brings a `savedPosition`; the arrows of the page (and Telegram's back button) push the parent route
// instead, so for the list of tags the position it was left at is remembered per path.
const TAGS_LIST = '/settings/tags'
const left = new Map<string, number>()

export function isTagsList(path: string): boolean {
  return path === TAGS_LIST || path === `${TAGS_LIST}/`
}

// (called before a navigation, while the page we leave is still on screen)
export function rememberScroll(from: RouteLocationNormalized, y: number): void {
  if (isTagsList(from.path)) left.set(TAGS_LIST, y)
}

export function forgetScroll(): void {
  left.clear()
}

export const scrollFor: RouterScrollBehavior = async (to, from, savedPosition) => {
  if (to.hash) return { el: to.hash }
  if (savedPosition) return savedPosition
  const y = left.get(TAGS_LIST)
  // Only when coming back from a page below the list; opening the list from elsewhere starts at the top as before.
  if (y === undefined || !isTagsList(to.path) || isTagsList(from.path) || !from.path.startsWith(`${TAGS_LIST}/`)) {
    return undefined
  }
  await nextTick() // (the list is on screen before the position is applied)
  return { left: 0, top: y }
}
